import React, { Fragment } from "react";
import { connect } from "react-redux";
import { any, func } from "prop-types";
import moment from "moment";
import history from "../../history";
import FormCreatorV2 from "../../common/FormCreatorV2";
import { postWoodlandForms } from "../../redux/actions/woodlandActions";
import {
  useForm,
  determineRadioAnswers,
} from "../../common/FormCreator/helpers";

const FireSafety = ({ appData, postWoodlandFormsFunc }) => {
  const initialState = {
    Group6: {
      title: "What 3 components are needed to start a fire?",
      type: "radio",
      radioOptions: [
        "Oxygen, water and fuel",
        "Fuel, ignition and oxygen",
        "Fuel, carbon dioxide and time",
        "Ignition, carbon dioxide and moisture",
      ],
      mandatory: true,
    },
    Group7: {
      title: "Why is it important to know the different classes of fire?",
      type: "radio",
      radioOptions: [
        "Because some cause greater damage than others",
        "Because some are less dangerous to a person's health",
        "Because everyone in a workplace needs to fight fire",
        "Because certain fires can only be fought with certain fire extinguishers",
      ],
      mandatory: true,
    },
    Group8: {
      title: "You discover a fire, what is the first thing you must do?",
      type: "radio",
      radioOptions: [
        "Raise the alarm",
        "Call the fire brigade",
        "Get out of the building",
        "Try to extinguish the fire",
      ],
      mandatory: true,
    },
    Group9: {
      title: "A water fire extinguisher should only be used on-?",
      type: "radio",
      radioOptions: [
        "Liquid fuel fires",
        "Fires involving gas",
        "Combustible material fires",
        "Fires involving electricity",
      ],
      mandatory: true,
    },
    Group10: {
      title: "In an event of a fire should you leave doors open?",
      type: "radio",
      radioOptions: ["Yes", "No"],
      mandatory: true,
    },
  };

  const [fields, setField] = useForm(initialState);
  const woodland = appData.woodlandGroupOnboarding;
  const submitted = woodland && woodland.fireSafety;
  const incidentReporting = woodland && woodland.incidentReporting;
  const manualHandling = woodland && woodland.manualHandling;

  const redirectBack = () => {
    history.push("/profile/edit/woodland-group-onboarding");
  };

  const handleSubmit = () => {
    const answers = determineRadioAnswers(fields);
    postWoodlandFormsFunc("fireSafety", {
      ...answers,
      date: moment().toISOString(),
    });
    if (manualHandling && incidentReporting) {
      postWoodlandFormsFunc("submit", {
        name: `${appData.firstName} ${appData.lastName}`,
        ...appData.woodlandGroupOnboarding.incidentReporting,
        ...appData.woodlandGroupOnboarding.manualHandling,
        ...answers,
        date: moment().toISOString(),
      });
    }
    redirectBack();
  };

  return (
    <>
      {submitted ? (
        redirectBack()
      ) : (
        <FormCreatorV2
          formTitle={"Fire Safety"}
          helper={""}
          fields={fields}
          setField={setField}
          handleCancel={() => redirectBack()}
          onboardingBranch={"woodlandBranch"}
          useSubmitText={true}
          handleSubmit={handleSubmit}
        />
      )}
    </>
  );
};

FireSafety.propTypes = {
  appData: any,
  postWoodlandFormsFunc: func,
};

const mapDispatchToProps = {
  postWoodlandFormsFunc: postWoodlandForms,
};

const mapStateToProps = (state) => ({
  appData: state.core.app,
});

const withRedux = connect(mapStateToProps, mapDispatchToProps);
export default withRedux(FireSafety);
